import { useLoadScript } from "@react-google-maps/api";
import Dashboard from "./components/Dashboard";
// AIzaSyAj01V7t9YYJXclypCYhq89TN4bDRl4kNk
const App = () => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyDJD2RrJbzpcGSs0hYCi5VoxjKNYf8ZpOU", //  "AIzaSyAj01V7t9YYJXclypCYhq89TN4bDRl4kNk", // process.env.REACT_APP_GOOGLE_API_KEY,
    libraries: ["drawing"],
  });

  return <div>{!isLoaded ? <h1>Loading...</h1> : <Dashboard />}</div>;
};

export default App;
